function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4 22L16 29L28 22",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4 16L16 23L28 16",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4 10L16 17L28 10L16 3L4 10Z",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgStack = function SvgStack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Stack.19b604ac.svg";
export { ForwardRef as ReactComponent };